import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'

import { ThemeColor } from 'utils/themes/types'

import { CoachOnboardingPrompt } from './CoachOnboardingPrompt'
import { ImageUploadButton } from './ImageUploadButton'

type ImageUploadProps = {
  programId?: string
  promptTitle?: string
  promptSubtitle?: string
  textColor?: ThemeColor
  buttonBackground?: ThemeColor
  onNext?: () => void
}

export const ImageUpload = ({
  programId,
  promptTitle,
  promptSubtitle,
  textColor,
  buttonBackground = 'v2black',
  onNext,
}: ImageUploadProps) => {
  const theme = useTheme()

  const computedStyles = StyleSheet.create({
    button: {
      backgroundColor: theme.colors[buttonBackground],
      borderRadius: 10,
      marginTop: 27,
    },
  })

  return (
    <Box flex={1} testID='ImageUploadContainer' padding='lg' backgroundColor='transparent'>
      <CoachOnboardingPrompt color={textColor} title={promptTitle} subtitle={promptSubtitle} />
      <Box testID='InputContainer' justifyContent='center' margin={{ top: 'md' }}>
        <ImageUploadButton programId={programId} />
        <Button
          type={buttonBackground}
          style={computedStyles.button}
          title='Finish'
          titleColor='white'
          onPress={onNext}
        />
      </Box>
    </Box>
  )
}
